import { gql } from '@apollo/client';

/**
 * 新增 / 全量更新 AOI 衍生属性 (按 aoiId + zipcode 自动决定 INSERT 还是 UPDATE)。
 */
export const UPSERT_AOI_ATTRIBUTE = gql`
  mutation UpsertAoiAttribute($input: BizAoiAttributeUpsertInput!) {
    upsertAoiAttribute(input: $input) {
      aoiId
      created
    }
  }
`;

export interface BizAoiAttributeLocationPointInput {
  lng: number;
  lat: number;
  remark?: string | null;
}

/** AOI 级门禁 code 入参。
 *
 * <p>id = biz_access_code 行主键, 编辑回传用: 查询返回什么就回传什么, 新增不填。
 * 服务端按 id 精确识别"改的是哪一行"(原地改, 反馈/审计锚点不断); 不回传时退化为
 * 按内容+位置推断, 行为兼容但有"同次保存删A加B被认成A改B"的固有歧义。 */
export interface BizAoiAttributeAccessCodeInput {
  id?: string | null;
  codeType: string;
  codeValue: string;
  /** PENDING_VERIFICATION / AVAILABLE / UNAVAILABLE */
  available?: string | null;
  remark?: string | null;
}

/** AOI 业务标签入参 (code 必须在字典内且启用; 层级 / 参数 JSON 由服务端校验)。 */
export interface BizAoiBizTagInput {
  tag: string;
  paramsJson?: string | null;
  remark?: string | null;
}

export interface BizAoiAttributeUpsertInput {
  aoiId: number;
  zipcode: string;
  aoiSourceId?: string | null;
  entryPoints?: BizAoiAttributeLocationPointInput[] | null;
  parkingPoints?: BizAoiAttributeLocationPointInput[] | null;
  accessCodes?: BizAoiAttributeAccessCodeInput[] | null;
  deliveryTime?: string | null;
  typeCode?: string | null;
  /**
   * 业务标签: 不传 / null = 不改 (老调用方无感), 空数组 = 清空, 非空 = 全量覆盖。
   * 与进门点 / 门禁码的 "null 视为无" 不同 —— 标签是新加字段, 不能让没升级的保存链路把它抹掉。
   */
  bizTags?: BizAoiBizTagInput[] | null;
}

export interface BizAoiAttributeUpsertResult {
  aoiId: number;
  /** true=本次为新增, false=本次为覆盖更新 */
  created: boolean;
}

export interface UpsertAoiAttributeResponse {
  upsertAoiAttribute: BizAoiAttributeUpsertResult;
}
